// app/src/Router.jsx — hash-based router for Kanjo Crew.
// Routes mounted under #/path; deep links work because index.html is the only entry.
// Stubs keep the navigation graph complete from day one (Chat/Schedule/Pay are
// Phases 2–4).

function StubScreen({ tab, title, subtitle }) {
  return (
    <KShell tab={tab}>
      <KHeader title={title} />
      <div style={{ padding: 28, textAlign: 'center', color: 'var(--on-soft)' }}>
        <div style={{ fontWeight: 700, color: 'var(--on)', marginBottom: 6 }}>{title}</div>
        <div style={{ fontSize: 13 }}>{subtitle}</div>
      </div>
    </KShell>
  );
}

const ROUTES = {
  '/board':    () => <BoardScreen />,
  '/chat':     () => <ChatScreen />,
  '/schedule': () => <ScheduleScreen />,
  '/pay':      () => <PayScreen />,
  '/you':      () => <YouScreen />,
  '/people':   () => <People />,
  '/join':     () => <Join />,
  '/billing':  () => <BillingScreen />,
};

function Router({ route }) {
  const path = (route || '').split('?')[0];
  const r = ROUTES[path];
  if (r) return r();
  return <BoardScreen />; // default
}

Object.assign(window, { Router, ROUTES, StubScreen });
